import * as React from 'react'

import { styled, spacing, Text } from '@thg-commerce/gravity-theme'
import { ArticlePreview, Separator } from '@thg-commerce/gravity-elements'
import { ArticlePreviewProps } from '@thg-commerce/gravity-elements/ArticlePreview/ArticlePreview'
import { ImageProps } from '@thg-commerce/gravity-elements/Image/Image'

interface ArticleProps extends Partial<ArticlePreviewProps> {
  title: string
  i18nAuthorText: string
  category: string
  description: string
  articleAge: string
  image: ImageProps
  articleUrl: string
  categoryUrl: string
  authorUrl: string
}

export interface FeaturedArticlesProps {
  i18nTitle: string
  articles: ArticleProps[]
}

const Title = styled.h3`
  ${Text('large1', 'alternate')}
  margin-bottom: ${spacing(4)};
`

const StyledSeparator = styled(Separator)`
  margin-top: ${spacing(4)};
  margin-bottom: ${spacing(4)};
`

export const FeaturedArticles = ({
  i18nTitle,
  articles,
}: FeaturedArticlesProps) => {
  return (
    <div>
      <Title>{i18nTitle}</Title>
      {articles.map((article, index) => (
        <React.Fragment key={index}>
          <StyledSeparator />
          <ArticlePreview {...article} direction="row" />
        </React.Fragment>
      ))}
    </div>
  )
}
